"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookingStartDateBeforeRuleEnd = exports.bookingStartDateAfterRuleStart = exports.bookingHasLongLeadTime = exports.underBookingPriceMax = exports.overBookingPriceMin = exports.overPropertyMinSize = exports.withinPropertySizeRange = void 0;
const differenceInDays_1 = __importDefault(require("date-fns/differenceInDays"));
const withinPropertySizeRange = (sleeps, max) => sleeps <= max;
exports.withinPropertySizeRange = withinPropertySizeRange;
const overPropertyMinSize = (sleeps, min) => sleeps >= min;
exports.overPropertyMinSize = overPropertyMinSize;
const overBookingPriceMin = (price, min) => price >= min;
exports.overBookingPriceMin = overBookingPriceMin;
const underBookingPriceMax = (price, max) => price <= max;
exports.underBookingPriceMax = underBookingPriceMax;
const bookingHasLongLeadTime = (bookingStartDate, usersCurrentDate, minLeadTime) => (0, differenceInDays_1.default)(bookingStartDate, usersCurrentDate) > minLeadTime;
exports.bookingHasLongLeadTime = bookingHasLongLeadTime;
const bookingStartDateAfterRuleStart = (bookingStartDate, bookingStartDateMin) => bookingStartDate >= bookingStartDateMin;
exports.bookingStartDateAfterRuleStart = bookingStartDateAfterRuleStart;
const bookingStartDateBeforeRuleEnd = (bookingStartDate, bookingStartDateMax) => bookingStartDate <= bookingStartDateMax;
exports.bookingStartDateBeforeRuleEnd = bookingStartDateBeforeRuleEnd;
//# sourceMappingURL=brand.utils.js.map